export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6943.3f8ef4cc.jpg";